import { VueModule } from '@Foundation';
import RelatedManualArticle from './code/Scripts/components/related-manual-article';

export default VueModule({
  components: {
    RelatedManualArticle
  }
});
